import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 13.25,
		cy: 13,
		r: 9.375,
		fill: "#141414"
	})
});
export default SvgCircle;
